import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Rynco Li
 * id EF0C4465-ACEB-44FA-BA7F-A0422E4481F6
 * name card-text
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-text.svg
 * tags
 */
export const CardTextIcon = createSvgIcon(<><path d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M5,13V15H16V13H5M5,9V11H19V9H5Z" /></>, 'CardTextIcon');
export default CardTextIcon